import React from "react";
import "../ScrollingLogos/scrollingLogos.scss";
import { BrandImg } from "..";

const ScrollingLogos = () => {
  return (
    <div className="marquee-wrapper">
      <div className="marquee-title">
      <p><strong>Trusted by</strong> leading brands worldwide</p>
      </div>
      <div className="marquee">
        <img src={BrandImg} alt="Client Logos" />
        <img src={BrandImg} alt="Client Logos Duplicate" />
      </div>
    </div>
  );
};

export default ScrollingLogos;
